import { CreateInsightDataFn } from '@ecosystem/newron-client-collections';
import { EmptyTabsPage, EnabledExportPages, ViewType } from '@hooks/export/Model';
import { useExportModal } from '@hooks/export/export-modal/UseExportModal';
import RetailerOverviewCollectionButton from '@pages/overview/retailer-overview-collection-button/RetailerOverviewCollectionButton.';
import { getDisplayNameFromHeaderKey } from '@models/PerformanceAnalysisboard';
import { ElementType } from '@utils/page-analytics/model/AnalyticTrackingBasePropertiesObj';
import {
  dataExportInitiatedTrackingFunction,
  useDataExportTracking,
} from '@utils/page-analytics/model/DataExportTracking';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { CollectionInsightType } from '@components/collections/Model';
import { WithExportButton, WithExportModal } from '@components/design';
import { CreateViewStateFn } from '@ecosystem/newron-client-lib';

interface RetailerOverviewHeaderIconProps {
  onChartDownload: (exportFormats: any) => Promise<void>;
  isDisabled: boolean;
  isPerformanceTrend: boolean;
  volume: string;
  title?: string;
  createInsightDataFn: CreateInsightDataFn<any>;
  collectionInsightType: CollectionInsightType;
  createViewStateFn?: CreateViewStateFn<any>;
}

const RetailerOverviewHeaderIcon: React.FC<RetailerOverviewHeaderIconProps> = ({
  isDisabled,
  onChartDownload,
  isPerformanceTrend = true,
  volume,
  createInsightDataFn,
  collectionInsightType,
  createViewStateFn,
}) => {
  const pagesConfig = usePageConfig();
  const handleDataExportTrackingFunction = useDataExportTracking('mainFiltersRO');

  const handleExportTracking = () => {
    handleDataExportTrackingFunction(
      {
        elementType: isPerformanceTrend ? ElementType.COMBINED_CHART : ElementType.LINE_CHART,
        elementKpi: getDisplayNameFromHeaderKey(pagesConfig.sortingOptions.headerKey, volume),
        elementSort: pagesConfig.sortingOptions,
      },
      dataExportInitiatedTrackingFunction,
    );
  };

  const {
    openExportModal,
    onCloseExportModal,
    onExportError,
    exportModalFormats,
    exportModalMessage,
    exportModalHeaderText,
    isExportModalOpen,
  } = useExportModal({
    currentPage: EnabledExportPages.RetailerOverview,
    currentTab: EmptyTabsPage.None,
    currentView: isPerformanceTrend ? ViewType.CombinedChart : ViewType.LineChart,
  });

  const onExportClick = () => {
    handleExportTracking();
    openExportModal();
  };

  return (
    <div className="flex-row">
      <RetailerOverviewCollectionButton
        createInsightDataFn={createInsightDataFn}
        isDisabled={isDisabled}
        collectionInsightType={collectionInsightType}
        createViewStateFn={createViewStateFn}
      />
      <WithExportButton disabled={isDisabled} onClick={onExportClick}></WithExportButton>
      <WithExportModal
        isShown={isExportModalOpen}
        title={exportModalHeaderText}
        exportFormats={exportModalFormats}
        message={exportModalMessage}
        download={onChartDownload}
        onClose={onCloseExportModal}
        onError={onExportError}
      />
    </div>
  );
};

export default RetailerOverviewHeaderIcon;
